import { TileConditions, TileDataColoursAndConditions } from "@/api/dtos";
import ColourConverter from "@/ColourConverter";
import ChosenThemeContext from "@/contexts/styles/ChosenThemeContext";
import { useContext, useMemo } from "react";

const EvaluateColour = ( coloursAndConditions: TileDataColoursAndConditions[], data: string ) => {
    const chosenTheme = useContext(ChosenThemeContext);
    
    return useMemo(() => {

        const colourAndCondition = coloursAndConditions.find((coloursAndCondition) => {
            if (!coloursAndCondition.conditions) {
                return true;
            }
            return EvaluateConditions(coloursAndCondition.conditions, data);
        });

        if (colourAndCondition) {
            return chosenTheme === 'dark' ? ColourConverter(colourAndCondition.darkColour) : ColourConverter(colourAndCondition.lightColour);
        } else {
            return undefined;
        }
        
    }, [coloursAndConditions, data, chosenTheme]);
};

const EvaluateConditions = (conditions: TileConditions[], data: string) => {
        return conditions?.every(condition => {
            switch (condition.operator) {
                case '==':
                    return data === condition.value;
                case '!=':
                    return data !== condition.value;
                case '<':
                    return Number(data) < Number(condition.value);
                case '>':
                    return Number(data) > Number(condition.value);
                case '<=':
                    return Number(data) <= Number(condition.value);
                case '>=':
                    return Number(data) >= Number(condition.value);
                default:
                    return false;
            }
        });
}

export default EvaluateColour;